'use strict';
// import './style.css';

export class FormSubscribe {
    constructor(options = []) {
        this.options = options;
        this.init();
    }

    init() {
        const instance = this

        document.querySelector('.js-subscribe-news').addEventListener("submit", function (e) {
            instance.sendForm(e)
        })
    }

    sendForm(e) {
        e.preventDefault()
        const instance = this
        let form = e.target;
        let url = form.getAttribute('action')
        let formData = new FormData(form)

        fetch(url, {
            method: 'POST',
            body: formData
        }).then(function (response) {
            if (response.status !== 200) {
                console.log('Looks like there was a problem. Status Code: ' + response.status)
                return
            }
            form.reset()
            instance.showSuccessMessage()
            // $.fancybox.open({
            //     type: 'ajax',
            //     src: '/local/ajax/popups/subscribe_success.php',
            //     touch: 'false'
            // });
        }).catch(function (err) {
            console.log('Fetch Error :-S', err)
        });
    }

    showSuccessMessage() {
        $('.dialogs .popup').removeClass('active').hide();
        $("#sendSubscribe").show();
        $('.dialogs').addClass('act');
        $('.dialogs').animate({'z-index':99}, 200, function() {
            $("#sendSubscribe").addClass('active');
        });
        $('body').css({'overflow-y':'hidden'});
    }
}